import { Sun, Moon } from 'lucide-react'
import { useTheme, type Theme } from './useTheme'

interface ThemeToggleProps {
  className?: string
  onThemeChange?: (theme: Theme) => void
}

export default function ThemeToggle({ className, onThemeChange }: ThemeToggleProps) {
  const { theme, toggle } = useTheme(onThemeChange)
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggle}
      aria-pressed={!isDark}
      aria-label={isDark ? 'Switch to bright mode' : 'Switch to dark mode'}
      title={isDark ? 'Bright / professional view' : 'Dark / lab mode'}
      className={className}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  )
}
